import { defineAction } from '~/prix'
import { z } from 'zod'
import propertyImprovementsFetchAction from './propertyImprovementsFetch.action.json' with { type: 'json' }
import { propertyImprovementsObject } from '../propertyImprovementsObject'

const propertyImprovementsFetchDefinition = defineAction({
  ...propertyImprovementsFetchAction,

  input: z.object({
    id: z.string().uuid(),
  }),
  output: propertyImprovementsObject,
})

export default propertyImprovementsFetchDefinition
